module.exports = __webpack_public_path__ + "media/images/main/k7-e6e26e7ddc76147769a096dbe2f7dc9e.jpg";